import { render } from "./wishlist.vue?vue&type=template&id=0c661755"
import script from "./wishlist.vue?vue&type=script&setup=true&lang=js"
export * from "./wishlist.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/wishlist.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c661755"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c661755', __exports__)) {
    api.reload('0c661755', __exports__)
  }
  
  module.hot.accept("./wishlist.vue?vue&type=template&id=0c661755", () => {
    api.rerender('0c661755', render)
  })

}


export default __exports__